import { ERole } from "../models/enums/role";
import auth from "../services/auth/AuthService";

const EDIT_CAPABLE_ROLES: ERole[] = [ERole.Admin, ERole.SuperAdmin];

const getCurrentRole = (): ERole | undefined => auth.user?.role;

export const canEdit = (role: ERole | undefined = getCurrentRole()): boolean =>
    role !== undefined && EDIT_CAPABLE_ROLES.includes(role);
